import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AUTO_LOGOUT_MINUTES = 30; // timeout duration

function useAutoLogout() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isPublicRoute =
      location.pathname === "/login" ||
      location.pathname === "/";

    if (isPublicRoute) return;

    let timeoutId;

    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // Logout user after timeout
        localStorage.clear();
        alert("You’ve been logged out due to inactivity.");
        navigate("/");
      }, AUTO_LOGOUT_MINUTES * 60 * 1000); // Convert to ms
    };

    // Activity listeners
    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer initially

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [navigate]);
}

export default useAutoLogout;
